import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import login from "./modules/login";
import student from './modules/student'
export default createStore({
  modules: {
    login,student
  },
  plugins: [createPersistedState()],
});
